export default __webpack_public_path__ + "static/media/faq_logging_in_cover.9ce5bc4d.svg";